import { engineComponent } from "neo-common";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { CreateFrameTimer, FrameTimerEventEmitter, FrameTimerEvents } from "../Utils/FrameTimer";
import { ImageElement } from "../Components/Elements/Graphics/ImageElement";
import { BaseElement } from "../Components/Elements/Graphics/BaseElement";
import { Tweens } from "../Components/Effects/Tweens";
import { PlayList } from "../Components/Sounds/PlayList";
import { SwitchElementExtended } from "../CustomComponents/SwitchElementExtended";

@engineComponent(ComponentTypes.DisplayObject)
export class Ball extends BaseElement {
    //******************************************************************************************************************
    //  EVENTS
    //******************************************************************************************************************

    public static BallStopped: string = "ballStopped";

    //******************************************************************************************************************
    //  SETTINGS
    //******************************************************************************************************************

    private static RotationSpeed: number = 60;

    private static BallStopDuration: number = 240;

    private static BallSpinStartAngle: number = 45;

    //******************************************************************************************************************
    //  VARIABLES
    //******************************************************************************************************************

    private _ballHolder: SwitchElementExtended;
    private _ball: ContainerElement;

    private _finalAngle: number;
    private _startOffsetAngle: number;

    private _stopAnimationIndex: number;

    //******************************************************************************************************************
    //  CONSTRUCTOR
    //******************************************************************************************************************

    constructor() {
        super();

        this._stopAnimationIndex = 0;
    }

    public createBall(ballHolder: SwitchElementExtended): void {
        this._ballHolder = ballHolder;

        if (this._ballHolder) {
            this._ballHolder.on(SwitchElement.FinishAnimation, this.ballStopped.bind(this));
            this._ball = <ContainerElement>this._ballHolder.getChildElementByName("Ball");
        }
    }

    public initialize(initAngle: number): void {
        this._ball.rotation = this.degrees2radians(initAngle);
    }

    public spinStart(currentRotation: number): void {
        //ToDo nastavit startovaciu poziciu pre lopticku
        let currentHolderAngle = this.radians2degrees(currentRotation);
        this._startOffsetAngle = Ball.BallSpinStartAngle - currentHolderAngle;
        this._ball.rotation = this.degrees2radians(this._startOffsetAngle);
        this._stopAnimationIndex = Math.floor(Math.random() * 6);

        PlayList.loop("SND_WheelBallLoop");

        if (this._ballHolder != null) {
            this._ballHolder.goToCase("SPIN");
        }
    }

    public spinStop(finalAngle: number, force: boolean = false): void {
        this._finalAngle = finalAngle - 360; //ball spinning in counter clockwise direction

        // console.log("%c FinalAngle: " + this._finalAngle, "font-size: 24px; color: #00A1DE");

        if (force) {
            this.forceStopBall();
        } else {
            this.preStopBall();
        }
    }

    private preStopBall(): void {
        if (this._ballHolder) {
            this._ballHolder.goToCase("PRE_STOP");

            let currentBallRotation = this.radians2degrees(this._ball.rotation) % 360;

            let angleStep = this.getAngleStep(currentBallRotation);
            let time = Math.round((Ball.RotationSpeed / 360) * Math.abs(angleStep));

            let newBallRotation = currentBallRotation + angleStep;

            // console.log("%c AngleStep: " + angleStep + " Time: " + time, "font-size: 24px; color: #00A1DE");
            // console.log("%c CurrentBallRotation: " + currentBallRotation + " New: " + newBallRotation, "font-size: 24px; color: #00A1DE");

            if (time == 0 || currentBallRotation == newBallRotation) {
                console.log("%c Skipped preStopBall tween", "font-size: 24px; color: #00A1DE");

                this.stopBall();
            } else {
                Tweens.customTween(this._ball, {
                    tween: "rotation",
                    tweenValues: [currentBallRotation, newBallRotation],
                    tweenDuration: [time],
                    callbackFunction: this.stopBall,
                    callbackScope: this,
                });
            }
        }
    }

    private getAngleStep(currentBallRotation: number): number {
        if (currentBallRotation < this._finalAngle) {
            return this._finalAngle - 360 - currentBallRotation;
        } else {
            return this._finalAngle - currentBallRotation;
        }
    }

    private stopBall(): void {
        if (this._ballHolder) {
            PlayList.stop("SND_WheelBallLoop");
            PlayList.play("SND_WheelBallStop_" + this._stopAnimationIndex);

            this._ballHolder.goToCase("SPIN_STOP_" + this._stopAnimationIndex);
        }
    }

    private forceStopBall(): void {
        PlayList.stop("SND_WheelBallLoop");
        PlayList.stop("SND_WheelBallStop_" + this._stopAnimationIndex);
        this._ballHolder.goToCase("IDLE");
    }

    private ballStopped(): void {
        this._ball.rotation = this.degrees2radians(this._finalAngle);
        this.emit(Ball.BallStopped);
    }

    public getWorldTransform(): PIXI.Matrix {
        if (this._ball != null) {
            return this._ball.childs["CenterPoint"].transform.worldTransform;
        }

        return null;
    }

    public getBallGlobalPosition(): PIXI.Point {
        if (this._ball != null) {
            return this._ball.childs["CenterPoint"].getGlobalPosition();
        }

        return null;
    }

    public getBallRotation(): number {
        if (this._ball != null) {
            return this._ball.rotation;
        }

        return null;
    }

    public getStopDuration(): number {
        if (this._ballHolder != null) {
            return this._ballHolder.getTimerDurationByCase("SPIN_STOP_" + this._stopAnimationIndex);
        }

        return 0;
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Ball.ts
 **/